export function definePropertySafe (obj, prop, descriptor) {
  try {
    return Object.definePropertySafe(obj, prop, descriptor)
  } catch(e) {
    console.warn('definePropertySafe', e)
  }

  return obj
}
